import React from 'react';
import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import type { CustomerAttendanceStatus } from '../../types/provider';

interface Props {
  status: CustomerAttendanceStatus | null | undefined;
  size?: 'sm' | 'md';
}

const CONFIRMED_BG = 'rgba(31,139,76,0.10)';
const CONFIRMED_COLOR = 'rgba(31,139,76,1)';
const DECLINED_BG = 'rgba(255,77,79,0.12)';
const DECLINED_COLOR = '#ff4d4f';

export const AttendanceStatusBadge: React.FC<Props> = ({ status, size = 'sm' }) => {
  if (status === null || status === undefined) return null;

  const isConfirmed = status === 'CONFIRMED';
  const bg = isConfirmed ? CONFIRMED_BG : DECLINED_BG;
  const color = isConfirmed ? CONFIRMED_COLOR : DECLINED_COLOR;
  const label = isConfirmed ? 'Tasdiqladi' : 'Kelmaydi';
  const Icon = isConfirmed ? CheckCircleFilled : CloseCircleFilled;

  const fontSize = size === 'md' ? 12 : 11;
  const padding = size === 'md' ? '4px 10px' : '3px 8px';
  const iconSize = size === 'md' ? 11 : 10;
  const gap = size === 'md' ? 5 : 4;

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap,
        fontSize,
        fontWeight: 600,
        color,
        background: bg,
        borderRadius: 20,
        padding,
        lineHeight: 1.2,
        whiteSpace: 'nowrap',
      }}
    >
      <Icon style={{ fontSize: iconSize }} />
      {label}
    </span>
  );
};
